<div class="p-d-flex p-jc-between p-mb-2">
    <h1 class="p-mb-0">Welcome, {{ user.givenName }}</h1>
    <div class="header-dropdowns" *ngIf="settings$ | async as settings">
      <p-dropdown
        [ngModel]="settings.period"
        (ngModelChange)="setPeriod($event)"
        appendTo="body"
        [options]="periodOptions"
        ></p-dropdown>
      <p-calendar
        *ngIf="!settings.isMonthMode"
        appendTo="body"
        [(ngModel)]="customPeriod"
        selectionMode="range"
        [readonlyInput]="true"
        styleClass="full-width"
        inputId="range"
        [disabled]="settings.customPeriodDisabled"
        (onClose)="validateCustomPeriod()"
        ></p-calendar>
      <p-calendar
        *ngIf="settings.isMonthMode"
        [(ngModel)]="month"
        dataType="string"
        view="month"
        dateFormat="MM yy"
        (onSelect)="setMonth(month)"
        showIcon="true"
        iconDisplay="input"
        [readonlyInput]="true"
        />
        <p-dropdown
          *ngIf="settings.showComparedTo"
          [ngModel]="settings.comparedTo"
          (ngModelChange)="setComparedTo($event)"
          appendTo="body"
          [options]="comparedToOptions"
          ></p-dropdown>
        <p-dropdown
          [ngModel]="settings.currency"
          (ngModelChange)="setCurrency($event)"
          appendTo="body"
          [options]="currencyOptions"
          ></p-dropdown>
    </div>
</div>
<div class="layout-dashboard jobsv2-{{ colorScheme.colorScheme.value }}" #layout>
  <app-karve-tabview
    [tabs]="tabs"
    baseUrl="/dashboard/"
    class="dashboard-tabs"
    ></app-karve-tabview>
  <div class="tabView">
    <router-outlet></router-outlet>
  </div>
</div>
